/* table-row.tsx generated by @compiled/babel-plugin v0.38.1 */
import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["isHighlighted", "children", "style", "testId", "className"];
import "./table-row.compiled.css";
import * as React from 'react';
import { ax, ix } from "@compiled/react/runtime";
import { forwardRef } from 'react';
var rowStyles = null;
var rowBackgroundStyles = null;
var rowHighlightedBackgroundStyles = null;

// eslint-disable-next-line @repo/internal/react/require-jsdoc
export var TableBodyRow = /*#__PURE__*/forwardRef(function (_ref, ref) {
  var isHighlighted = _ref.isHighlighted,
    children = _ref.children,
    style = _ref.style,
    testId = _ref.testId,
    className = _ref.className,
    rest = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("tr", _extends({
    // eslint-disable-next-line @atlaskit/ui-styling-standard/enforce-style-prop -- Ignored via go/DSP-18766
    style: style,
    /**
     * We rely on this `className` for the `RankableTableBodyRow` to apply extra styles.
     * With Compiled it needs to be statically analyzable. It does not get applied via spread props.
     */
    // eslint-disable-next-line @atlaskit/ui-styling-standard/no-classname-prop
    className: ax(["_bfhkqtfy _1ygbsglb _1ah312gs", isHighlighted ? "_bfhktkjs _irr31ae3" : "_irr3s8ts", className])
  }, rest, {
    ref: ref,
    "data-testid": testId
  }), children);
});